module.exports = __webpack_public_path__ + "img/3-4.d5172350.jpg";